<template>
  <div class="forget-index">
    <div class="main">
      <div class="l-img"></div>
      <div class="r-text p20">
        <el-tabs v-model="activeName" class="e-tabs">
          <el-tab-pane label="忘记密码" name="aa">
            <el-form
              ref="forget"
              :model="forgetRuleForm"
              :rules="forgetRules"
              class="demo-ruleForm mt20"
            >
              <el-form-item label="+86" prop="mobile" class="numItem">
                <el-input
                  v-model="forgetRuleForm.mobile"
                  placeholder="请输入手机号"
                  maxlength="11"
                  class="el-int"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code" class="mt20">
                <el-input
                  v-model="forgetRuleForm.code"
                  maxlength="6"
                  class="el-int code"
                ></el-input>
                <el-button
                  type="primary"
                  class="send"
                  @click="send"
                  v-if="isShowSend"
                  >发送验证码</el-button
                >
                <div class="sendTime" v-if="!isShowSend">
                  {{ timeNum }}S重新发送
                </div>
              </el-form-item>
              <el-form-item label="输入密码" class="mt20" prop="password">
                <el-input
                  v-model="forgetRuleForm.password"
                  placeholder="请输入新密码"
                  class="el-int"
                  type="password"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="确认密码"
                class="mt20"
                prop="password_confirmation"
              >
                <el-input
                  v-model="forgetRuleForm.password_confirmation"
                  placeholder="请再次输入密码"
                  class="el-int"
                  type="password"
                ></el-input>
              </el-form-item>
              <el-button
                type="primary"
                :class="isAffirm ? 'register-btn isAffirm' : 'register-btn'"
                :disabled="!isAffirm"
                @click="submit(forget)"
                >立即重置</el-button
              >
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, toRefs, defineComponent, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElForm, ElMessage } from "element-plus";
import { forgetPassword } from "@/api/login";
import { sendCode } from "@/api/login";

type FormInstance = InstanceType<typeof ElForm>;
export default defineComponent({
  name: "forgetPassword",

  setup({}, { emit }) {
    const router = useRouter();
    const activeName = ref("aa");
    const isShowSend = ref(true);
    const timeNum = ref(60);
    const countDown = ref();
    const forget = ref<FormInstance>();
    const isAffirm = ref(false);

    const forgetRuleForm = reactive({
      mobile: "",
      code: "",
      password: "",
      password_confirmation: "",
    });

    const vaildateMobile = (rule: any, value: any, callback: any) => {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const forgetRules = reactive({
      mobile: [
        {
          required: true,
          message: "请输入手机号",
          trigger: "blur",
        },
        { validator: vaildateMobile, trigger: "change" },
      ],
      password: [
        {
          required: true,
          message: "请输入新密码",
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      ],
      password_confirmation: [
        {
          required: true,
          message: "请再次输入密码",
          trigger: "blur",
        },
      ],
    });
    // 立即重置
    const submit = (formEl: FormInstance | undefined): void => {
      (formEl as any).validate((valid: any) => {
        if (valid) {
          forgetPassword(forgetRuleForm).then((res: any) => {
            if (res.code == 0) {
              ElMessage.success("密码重置成功");
              if (windowW > 850) {
                emit("switch", "login");
              } else {
                router.push({ name: "login" });
              }
            }
          });
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    // 发送验证码
    const send = (): void => {
      sendCode({ mobile: forgetRuleForm.mobile }).then((res: any) => {
        if (res.code == 0) {
          ElMessage.success(res.msg);
          getSetInterval();
        }
      });
    };

    //倒计时60s
    const getSetInterval = (): void => {
      timeNum.value = 60;
      countDown.value = setInterval(() => {
        setTimeout(() => {
          if (timeNum.value > 0 && timeNum.value <= 60) {
            isShowSend.value = false;
            timeNum.value--;
          } else {
            isShowSend.value = true;
            clearInterval(countDown.value);
          }
        }, 0);
      }, 1000);
    };
    watchEffect(() => {
      if (
        forgetRuleForm.mobile.length == 11 &&
        forgetRuleForm.code.length == 6 &&
        forgetRuleForm.password.length > 5 &&
        forgetRuleForm.password_confirmation.length > 5
      ) {
        isAffirm.value = true;
      } else {
        isAffirm.value = false;
      }
    });

    // 判断是pc端还是移动端
    const windowW = window.innerWidth;
    return {
      send,
      isShowSend,
      timeNum,
      countDown,
      forget,
      forgetRuleForm,
      activeName,
      forgetRules,
      submit,
      isAffirm,
      windowW,
    };
  },
});
</script>
<style lang="less">
@import url("@/assets/styles/login.less");
.e-tabs {
  .el-tabs__nav-scroll {
    font-size: 14px !important;
  }
  .el-tabs__item {
    font-size: 18px !important;
    color: #999999 !important;
    font-weight: bold;
  }
  .el-tabs__item.is-active {
    color: #191c29 !important;
    background: transparent;
  }
  .el-tabs__active-bar {
    background-color: #191c29 !important;
  }
  .el-tabs__nav-wrap {
    height: 60px !important;
  }
  .el-tabs__nav {
    height: 60px !important;
  }
}

@media only screen and (max-width: 850px) {
  body,
  html {
    height: 100%;
  }
  .forget-index {
    .e-tabs .el-tabs__item {
      font-size: 14px !important;
      padding: 10px;
      line-height: 25px;
      width: 70px;
      text-align: center;
    }
    .demo-ruleForm {
      padding-top: 0.5rem;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import url("@/assets/styles/common.less");
.forget-index {
  .boxSize(100%,100%);
  .header_logo {
    width: 300px;
    .Position(relative,300px);
    padding-top: 20px;
    .Flex(flex-start,center);
    .font(#B0B1B5,16px);
  }
  .main {
    .boxSize(100%,460px);
    .Flex(center);
    border-radius: 4px;
    .l-img {
      background: url("@/assets/images/register/left_bg.png");
      background-size: 100% 100%;
      padding: 30px;
      box-sizing: border-box;
      position: relative;
      .boxSize(45%,100%);
      .p1 {
        font-size: 16px;
        color: #ffffff;
        line-height: 32px;
      }
      .line {
        width: 18px;
        height: 6px;
        background: #ffffff;
        margin-top: 12px;
      }
      .loginLogo {
        position: absolute;
        left: 30px;
        bottom: 40px;
      }
    }

    .r-text {
      background-color: #fff;
      padding: 30px;
      .boxSize(calc(55% - 60px),calc(100% - 60px));
    }
    .register-btn {
      border: none;
      .boxSize(100%,40px);
      background: #f1f1f1;
      .font(#D1D2D5,16px);
      &:hover {
        background: #f1f1f1;
        .font(#D1D2D5,16px);
      }
      &.isAffirm {
        background: #ffca28;
        color: #333333;
        &:hover {
          background: #ffca28;
          color: #333333;
        }
      }
    }
    .send {
      border: none;
      .boxSize(49%,40px);
      background-color: #f4f4f4;
      .font(#191c29,15px);
    }
    .sendTime {
      .boxSize(49%,40px);
      border-radius: 4px;
      background-color: #f0f0f0;
      .font(#9f9f9f,15px);
      border: none;
      line-height: 40px;
      text-align: center;
    }
  }
}
@media only screen and (max-width: 850px) {
  .forget-index {
    .boxSize(100%,100%);
    background-size: 100% 100%;
    // overflow: hidden;
    .header_logo {
      left: 20px;
      top: 11%;
    }
    .main {
      width: calc(100% - 40px);
      height: auto;
      padding: 20px;
      top: 39%;
      .l-img {
        display: none;
      }
      .r-text {
        width: 100%;
        padding: 0;
      }
    }
  }
}
@media only screen and (max-width: 667px) {
  .forget-index .header_logo {
    top: 6%;
  }
}
</style>